import React from 'react';

const FourthContainer = ({ data, onClick }) => {
  return (
    <div onClick={onClick} className='mb-8 text-xxs sm:text-xs md:text-sm lg:text-lg xl:text-xl'>
      <div className='flex w-full border border-black'>
        <div className='flex flex-col w-[12%] border border-black'>
          <div className='bg-blue-200 h-[40px] sm:h-[60px] md:h-[80px] flex justify-center items-center text-center border-b-2 border-black'>
            Utility
          </div>
          <div className='bg-blue-200 h-[40px] sm:h-[60px] md:h-[80px] flex justify-center items-center text-center'>
            전력(kw)
            <br />
            LNG(i)
          </div>
        </div>
        <div className='flex flex-col w-[24%] border border-black'>
          <div className='bg-blue-200 h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b-2 border-black'>
            사용량/톤
          </div>
          <div className='flex'>
            <div className='flex flex-col flex-grow border-r border-black'>
              <div className='h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-b-2 border-black'>
                목표
              </div>
              <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
              <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center'></div>
            </div>
            <div className='flex flex-col flex-grow border-l border-black'>
              <div className='h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-b-2 border-black'>
                실적
              </div>
              <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
              <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center'></div>
            </div>
          </div>
        </div>
        <div className='flex flex-col w-[24%] border border-black'>
          <div className='bg-blue-200 h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b-2 border-black'>
            누계 사용량
          </div>
          <div className='flex'>
            <div className='flex flex-col flex-grow border-r border-black'>
              <div className='h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-b-2 border-black'>
                목표
              </div>
              <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
              <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b'></div>
            </div>
            <div className='flex flex-col flex-grow border-l border-black'>
              <div className='h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-b-2 border-black'>
                실적
              </div>
              <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
              <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b'></div>
            </div>
          </div>
        </div>
        <div className='flex flex-col w-[24%] border border-black'>
          <div className='bg-blue-200 h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b-2 border-black'>
            누계금액/톤
          </div>
          <div className='flex'>
            <div className='flex flex-col flex-grow border-r border-black'>
              <div className='h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-b-2 border-black'>
                목표
              </div>
              <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
              <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b'></div>
            </div>
            <div className='flex flex-col flex-grow border-l border-black'>
              <div className='h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-b-2 border-black'>
                실적
              </div>
              <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
              <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b'></div>
            </div>
          </div>
        </div>
        <div className='flex flex-col w-[24%] border border-black'>
          <div className='bg-blue-200 h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b-2 border-black'>
            누계금액
          </div>
          <div className='flex'>
            <div className='flex flex-col flex-grow border-r border-black'>
              <div className='h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-b-2 border-black'>
                목표
              </div>
              <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
              <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center'></div>
            </div>
            <div className='flex flex-col flex-grow border-l border-black'>
              <div className='h-[20px] sm:h-[30px] md:h-[40px] bg-blue-200 flex justify-center items-center text-center border-b-2 border-black'>
                실적
              </div>
              <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center border-b border-gray-400'></div>
              <div className='h-[20px] sm:h-[30px] md:h-[40px] flex justify-center items-center text-center'></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FourthContainer;
